/**
 * El idioma del panel del Centro: inglés por omisión, español a elección. Se recuerda en
 * este navegador (no en el usuario: el panel es de Kuanta Bridge y cada quien usa el suyo).
 *
 * Este archivo no importa los textos: lo usa también lib/formato, que los textos a su vez
 * importan.
 */
export type Idioma = 'en' | 'es';
export const IDIOMAS: Idioma[] = ['en', 'es'];
export const IDIOMA_POR_OMISION: Idioma = 'en';
const CLAVE = 'knoc-centro-idioma';

export const esIdioma = (x: unknown): x is Idioma => x === 'en' || x === 'es';

function leer(): Idioma {
  try {
    const v = localStorage.getItem(CLAVE);
    return esIdioma(v) ? v : IDIOMA_POR_OMISION;
  } catch {
    return IDIOMA_POR_OMISION;
  }
}

let actual: Idioma = leer();
// el lector de pantalla y el corrector del navegador saben en qué idioma está la página
if (typeof document !== 'undefined') document.documentElement.lang = actual;
const oyentes = new Set<() => void>();

export const idioma = (): Idioma => actual;

/** Para Intl: fechas y números como se escriben en cada idioma (la hora es la de Costa Rica). */
export const locale = (): string => (actual === 'es' ? 'es-CR' : 'en-US');

export function ponerIdioma(i: Idioma) {
  if (typeof document !== 'undefined') document.documentElement.lang = i;
  if (i === actual) return;
  actual = i;
  try {
    localStorage.setItem(CLAVE, i);
  } catch {
    /* navegador sin almacenamiento: vale hasta recargar */
  }
  for (const f of oyentes) f();
}

export function suscribir(f: () => void): () => void {
  oyentes.add(f);
  return () => oyentes.delete(f);
}
